import { buildApiListQueryHook, buildApiMutationHook } from "../_shared/helpers";
import { staleFor } from "../_shared/types";

import { ShiftType } from "./types";

export const useListScheduleShiftTypeQuery = buildApiListQueryHook<
  ShiftType.Schedule.API.List.QueryParams,
  ShiftType.Schedule.API.List.Response
>(ShiftType.Schedule.API.List.PATH, {
  staleTime: staleFor(1).hour,
});

export const useListUnitShiftTypeQuery = buildApiListQueryHook<
  ShiftType.Unit.API.List.QueryParams,
  ShiftType.Unit.API.List.Response
>(ShiftType.Unit.API.List.PATH, {
  staleTime: staleFor(1).hour,
});

export const useDeleteScheduleShiftTypeMutation = buildApiMutationHook<
  ShiftType.Schedule.API.Delete.QueryParams,
  ShiftType.Schedule.API.Delete.Response
>(ShiftType.Schedule.API.Delete.PATH, "delete");
